import _ from 'underscore'
import $ from 'jquery'
import TemplateView from '../../TemplateView'
import UserTime from '../../user_time'
import {KEY_CODE_ENTER} from '../../keyCodes'
import {handleEscape} from '../../atBrowserUtils'
import LoadingControlMixin from '../LoadingControlMixin'
import SimpleTooltip from '../../SimpleTooltip'
import messageResource from '../../messageResource'

const TimeEditor = function($containerEl, editable, editablePlaceholderText = 'N/A', nonEditablePlaceholderText = 'N/A', onChangeCb = () => {})
{
    TemplateView.call(this, $containerEl);
    this.editable = editable;
    this.editablePlaceholderText = editablePlaceholderText;
    this.nonEditablePlaceholderText = nonEditablePlaceholderText;
    this.onChangeCb = onChangeCb
};

TimeEditor.prototype = _.create(TemplateView.prototype, {
    html: "<div class='timeEditor'>" +
          "  <div class='value'></div>" +
          "  <input type='text' placeholder='<%-this.placeholder%>' maxlength='9'/>" +
          "</div>",

    updateOnInit: false,

    afterRender: function()
    {
        var self = this;
        this.time = null;
        this.disabled = false;
        this.$el.toggleClass('editable', this.editable);
        this.updatePlaceholderText(this.editable)
        this.$value = this.find(".value");
        this.$input = this.find("input");

        const tooltip = new SimpleTooltip({ text: messageResource.getMessage("task.time_editor.error", [SystemSettings.decimalSeparator]) }).init($('body'));
        tooltip.setEnabled(false);
        tooltip.subscribeToMouseEvents(this.$el);

        this.$input.placeholder();
        this.bindClick(function()
                       {
                           if (!self.editable || self.disabled || this.isLoading())
                               return;

                           self._startEditing();
                       });
        this.$input.valueChanged(function()
                                 {
                                     var inputValue = self.$input.pVal();
                                     if (inputValue === "")
                                     {
                                         self.currentEditingTime = null;
                                     }
                                     else
                                     {
                                         var time = UserTime.parseTimeWithSystemSettings(inputValue, true);
                                         // max time is 10^6 hours
                                         if (_.isNumber(time) && time >= 0 && time < 60 * 1000000)
                                         {
                                             self.hasError = false;
                                             tooltip.setEnabled(false);
                                             self.$el.removeClass("error");
                                             self.currentEditingTime = time;
                                         }
                                         else
                                         {
                                             self.hasError = true;
                                             tooltip.setEnabled(true);
                                             self.$el.addClass("error");
                                         }
                                     }
                                 });
        this.$input.blur(function()
                         {
                             if (self.editing)
                             {
                                 const isValidNonEmptyTime = !self.hasError && !_.isUndefined(self.currentEditingTime)
                                 if (isValidNonEmptyTime) {
                                     const newTime = self.currentEditingTime === 0 ? null : self.currentEditingTime
                                     self._triggerChange(newTime);
                                 }
                                 tooltip.setEnabled(false);
                                 self._stopEditing();
                             }
                         });
        this.$input.keydown(function(e)
                             {
                                 if (e.which === KEY_CODE_ENTER)
                                     self.$input.blur();
                                 handleEscape(function(e)
                                              {
                                                  stopEventPropagation(e);
                                                  self.$input.blur();
                                              }, e);
                             });
    },

    update: function()
    {
        var hasTime = _.isNumber(this.time);
        if (hasTime)
        {
            this.$value.text(UserTime.formatTimeWithDigitSeparator(this.time));
        }
        else
        {
            this.$value.text(this.placeholder)
        }
        this.$el.toggleClass("empty", !hasTime);
        this.$el.toggleClass("disabled", this.disabled);
        this.$el.toggleClass('editable', this.editable);
    },

    getTime: function()
    {
        return this.time;
    },

    setTime: function(time)
    {
        this.time = time;
        this.update();
    },

    isDisabled: function()
    {
        return this.disabled;
    },

    setDisabled: function(disabled)
    {
        this.disabled = disabled;
        this.update();
    },

    updatePlaceholderText(editable)
    {
        this.placeholder = editable ? this.editablePlaceholderText : this.nonEditablePlaceholderText;
    },

    _startEditing: function()
    {
        if (this.editable && !this.editing)
        {
            delete this.currentEditingTime;
            this.editing = true;
            this.$el.addClass("editing");
            this._resetInputValue();
            this.$input.focus();
            this.$input.select();
            $(this).trigger("startEditing");
        }
    },

    _stopEditing: function()
    {
        if (this.editable && this.editing)
        {
            this.editing = false;
            this.$el.removeClass("editing");
            $(this).trigger("stopEditing");
        }
    },

    _triggerChange: function(time)
    {
        this.time = time;
        this.update();
        this.onChangeCb(time)
        $(this).trigger("change", time);
    },

    _resetInputValue: function()
    {
        this.hasError = false;
        var value = _.isNumber(this.time) ? UserTime.formatTimeWithDigitSeparator(this.time) : "";
        this.$input.pVal(value);
        this.$input[0].prevValue = value;
        this.$el.removeClass("error");
    },

    setEditable: function(editable)
    {
        this.editable = editable;
        this.updatePlaceholderText(editable)
        this.update()
    },

    placeholder: 'N/A'
});


_.extend(TimeEditor.prototype, LoadingControlMixin);

export default TimeEditor



// WEBPACK FOOTER //
// ./web/js/controls/task/TimeEditor.js